/*
  Kopstorm Firmhouse Buy Box (VGNMY)
  Syncs the widget radios with the Shapes product form:
  - keeps a hidden "selling_plan" input in every /cart/add form
    (Firmhouse Shopify Native Checkout only needs this parameter)
  - switches the selected variant through the theme's own
    select[name="id"] so the Alpine Product island stays in sync
  - keeps a hidden "quantity" input in sync in quantity mode
*/
(function () {
  'use strict';

  function initBuyBox(root) {
    if (root.dataset.kopFhInit === 'true') return;
    root.dataset.kopFhInit = 'true';

    var sectionId = root.getAttribute('data-section-id');
    var sectionEl =
      document.getElementById('shopify-section-' + sectionId) || document;
    var planInputTemplate = root.querySelector('.kop-fh__selling-plan-input');
    var mode = root.getAttribute('data-mode') || 'variants';

    function getForms() {
      var forms = [];
      var all = sectionEl.querySelectorAll('form[action*="/cart/add"]');
      for (var i = 0; i < all.length; i++) {
        // Skip installment forms, mirrors the Firmhouse reference integration
        if (all[i].querySelector('[name="id"]')) forms.push(all[i]);
      }
      return forms;
    }

    function ensureHiddenInput(form, name, className) {
      var input = form.querySelector('input.' + className);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.className = className;
        form.appendChild(input);
      }
      return input;
    }

    function selectedRadio() {
      return root.querySelector('input.kop-fh__radio:checked');
    }

    function syncAlpine(variantId) {
      // Shapes drives its product state (price, media, availability,
      // sticky bar) from Alpine "Product" on the data-island root.
      var island = sectionEl.querySelector('data-island[x-data]');
      if (!island) return false;
      var data = null;
      if (window.Alpine && typeof window.Alpine.$data === 'function') {
        data = window.Alpine.$data(island);
      } else if (island._x_dataStack && island._x_dataStack[0]) {
        data = island._x_dataStack[0];
      }
      if (!data || typeof data.getVariantById !== 'function') return false;
      var variant = data.getVariantById(Number(variantId));
      if (!variant) return false;
      if (!data.currentVariant || data.currentVariant.id !== variant.id) {
        data.currentVariant = variant;
      }
      return true;
    }

    function setVariant(form, variantId) {
      var control =
        form.querySelector('select[name="id"]') ||
        form.querySelector('input[name="id"]');
      if (!control) return;
      if (String(control.value) === String(variantId)) return;
      control.value = String(variantId);
      // Fallback path when Alpine is unreachable: FormData still reads
      // this control on submit, so the correct variant is added.
      control.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var applying = false;

    function apply() {
      var radio = selectedRadio();
      if (!radio) return;
      applying = true;

      var isSubscription = radio.getAttribute('data-kop-fh-type') === 'subscription';
      var planId = radio.getAttribute('data-selling-plan-id') || '';
      var variantId = radio.getAttribute('data-variant-id');
      var quantity = radio.getAttribute('data-quantity') || '1';

      var forms = getForms();
      for (var i = 0; i < forms.length; i++) {
        var form = forms[i];

        var planInput = ensureHiddenInput(
          form,
          'selling_plan',
          'kop-fh-selling-plan'
        );
        planInput.value = isSubscription ? planId : '';

        if (mode === 'quantity') {
          var visibleQty = form.querySelector(
            'input[name="quantity"]:not(.kop-fh-quantity)'
          );
          if (visibleQty) {
            visibleQty.value = quantity;
            visibleQty.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            ensureHiddenInput(form, 'quantity', 'kop-fh-quantity').value =
              quantity;
          }
        }

        setVariant(form, variantId);
      }

      syncAlpine(variantId);
      applying = false;
    }

    // The template hidden input never submits from inside the widget
    if (planInputTemplate) planInputTemplate.disabled = true;

    root.addEventListener('change', function (event) {
      if (event.target && event.target.classList.contains('kop-fh__radio')) {
        apply();
      }
    });

    // If the theme's own variant picker is still enabled and the visitor
    // changes it, mirror the selection back onto the widget.
    sectionEl.addEventListener('change', function (event) {
      if (applying) return;
      var target = event.target;
      if (!target || target.name !== 'id') return;
      if (root.contains(target)) return;
      var match = root.querySelector(
        'input.kop-fh__radio[data-kop-fh-type="one_time"][data-variant-id="' +
          target.value +
          '"]'
      );
      if (match && !match.checked) {
        match.checked = true;
        apply();
      }
    });

    // Only one-time Mushroom Gummies may carry the bundle discount marker.
    getForms().forEach(function (form) {
      form.addEventListener('submit', apply, true);
      form.addEventListener('formdata', function (event) {
        var choice = selectedRadio();
        if (!choice || choice.getAttribute('data-variant-id') !== '47731580272987') return;
        var data = event.formData;
        data.set('id', choice.getAttribute('data-variant-id'));
        data.set('quantity', choice.getAttribute('data-quantity') || '1');
        data.delete('properties[__kaching_bundles]');
        if (choice.getAttribute('data-kop-fh-type') === 'subscription') {
          data.set('selling_plan', choice.getAttribute('data-selling-plan-id'));
          return;
        }
        data.delete('selling_plan');
        var bundle = document.querySelector('[data-kop-fh-kaching] kaching-bundles-block');
        if (!bundle || typeof bundle.items !== 'function') return;
        bundle.sellingPlanId = undefined;
        bundle.quantity = Number(choice.getAttribute('data-quantity') || 1);
        var item = bundle.items().find(function (line) { return String(line.id) === '47731580272987'; });
        if (item && item.properties) Object.keys(item.properties).forEach(function (key) {
          data.set('properties[' + key + ']', item.properties[key]);
        });
      });
    });

    apply();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-kop-fh]');
    for (var i = 0; i < roots.length; i++) initBuyBox(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
